import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import styled from "styled-components";
import React from "react";
import { IMedicalHistrory } from "../types/IInjuryData";
import U16 from "../assets/extraclubicons/U16.svg";
import U17 from "../assets/extraclubicons/U17.svg";
import U18 from "../assets/extraclubicons/U18.svg";
import U19 from "../assets/extraclubicons/U19.svg";
import U20 from "../assets/extraclubicons/U20.svg";
import U21 from "../assets/extraclubicons/U21.svg";
import noImageClub from "../assets/icons/noImageClub.svg";
import { useNavigate } from "react-router-dom";
import CustomizedTooltips from "./Tooltip";

const extraClubArray = [
  { id: "U16", img: U16 },
  { id: "U17", img: U17 },
  { id: "U18", img: U18 },
  { id: "U19", img: U19 },
  { id: "U20", img: U20 },
  { id: "U21", img: U21 },
];

const ClubLogoNameHolder = styled.div`
  & .clubLogoSVG {
    filter: ${({ theme }) =>
      theme.mode === "light"
        ? "invert(46%) sepia(100%) saturate(1989%) hue-rotate(1deg) brightness(104%) contrast(106%)"
        : "invert(59%) sepia(84%) saturate(2319%) hue-rotate(127deg) brightness(100%) contrast(101%)"};
  }
`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 16,
    color: theme.NumberColor,
    fontWeight: 500,
    fontFamily: "Aeonik",
    borderBottom: `1px solid ${theme.playerDataBorder}`,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: theme.playerDataValueColor,
    fontFamily: "DM Mono",
    border: 0,
    fontWeight: 500,
    textTransform: "uppercase",
  },
  "& img": {
    height: "32px",
    width: "32px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  height: "80px",
  "&:nth-of-type(even)": {
    backgroundColor: theme.playerCardBackground,
    border: 0,
  },
}));

interface CustomTableProps {
  data?: any[];
  showSpecificColumns?: boolean;
  headers?: string[];
  rows?:
    | {
        Date: string;
        "From Club": [string, string];
        "To Club": [string, string];
        "Published Transfer Fee": string;
      }[]
    | IMedicalHistrory[];
}

const CustomTable: React.FC<CustomTableProps> = ({ data, showSpecificColumns, headers, rows }) => {
  const navigate = useNavigate();
  const isImageUrl = (url: string) => {
    return url.match(/\.(jpeg|jpg|gif|png|svg)$/) !== null;
  };

  return (
    <TableContainer component={Paper} style={{ backgroundColor: "transparent", boxShadow: "none", marginTop: "24px" }}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            {headers?.map((header) => (
              <StyledTableCell key={header}>{header}</StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row, rowIndex) => (
            <StyledTableRow key={rowIndex}>
              {Object.values(row).map((value, cellIndex) => (
                <StyledTableCell key={cellIndex}>
                  {Array.isArray(value) ? (
                    <ClubLogoNameHolder className="clubLogoNameHolder">
                      {extraClubArray.find((club) => String(value[1]).includes(club.id))?.img ? (
                        <CustomizedTooltips title={String(value[1])}>
                          <img
                            className="clubLogoSVG"
                            src={extraClubArray.find((club) => String(value[1]).includes(club.id))?.img}
                            onClick={() => navigate(`/club/${value[2]}`)}
                            style={{ cursor: "pointer" }}
                          />
                        </CustomizedTooltips>
                      ) : value[0] && value[1] ? (
                        <CustomizedTooltips title={String(value[1])}>
                          <img src={value[0]} onClick={() => navigate(`/club/${value[2]}`)} style={{ cursor: "pointer" }} />
                        </CustomizedTooltips>
                      ) : (
                        <CustomizedTooltips title={String(value[1])}>
                          <img src={noImageClub} onClick={() => navigate(`/club/${value[2]}`)} style={{ cursor: "pointer" }} />
                        </CustomizedTooltips>
                      )}
                      <span onClick={() => navigate(`/club/${value[2]}`)} style={{ cursor: "pointer" }}>
                        {String(value[1])}
                      </span>
                    </ClubLogoNameHolder>
                  ) : value.toString().includes("\n") ? (
                    <div className="end-of-loan-container">
                      {value
                        .toString()
                        .split("\n")
                        .map((text: string, index: number) => (
                          <span key={index}>{text}</span>
                        ))}
                    </div>
                  ) : (
                    <span>{String(value)}</span>
                  )}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomTable;
